import { Button, ButtonProps, styled } from "@mui/material";

const StyledButton = styled(Button)(() => ({
  width: "35px",
  height: "35px",
  minWidth: "35px",
}));

export const RichTextIconButton = (props: Omit<ButtonProps, "disableRipple">) => (
  <StyledButton disableRipple {...props} />
);
